import styles from "../CreatorsPage.module.scss";
import { Compass, Instagram, MapPin, MoneyBag, SMark, Sparkle } from "./icons";
import { img } from "./images";
import { CREATOR_PAGE_PATH } from "./links";
import HeroPhone from "./HeroPhone";

const Hero = () => (
	<section className={styles.hero} aria-labelledby="h1">
		<div className={styles.wrap}>
			<div className={styles.heroTop}>
				<div className={styles.heroCopy}>
					<div className={styles.pills}>
						<span className={styles.pillGet}>
							<SMark />
							Stippl Creators
						</span>
						<span className={styles.joined}>
							<span className={styles.avs}>
								<img src={img("avatar-1.webp")} alt="" />
								<img src={img("avatar-2.webp")} alt="" />
								<img src={img("avatar-3.webp")} alt="" />
								<img src={img("avatar-4.webp")} alt="" />
								<img src={img("avatar-5.webp")} alt="" />
							</span>
							<span>
								<span className={styles.stars}>★★★★★</span>
								<br />
								Joined by <b>1.5M+</b> travellers
							</span>
						</span>
					</div>
					<span className={styles.pillPurple}>
						<Sparkle /> Always at least €0.50 per traveller
					</span>
					<h1 id="h1">
						Your audience saves your content.{" "}
						<span className={styles.u}>
							Now they can{" "}
							<span className={styles.sw}>
								travel it.
								<svg viewBox="0 0 300 20" preserveAspectRatio="none" aria-hidden="true">
									<path d="M3 14 C 70 4, 160 3, 297 10" fill="none" stroke="#13c892" strokeWidth="6" strokeLinecap="round" />
								</svg>
							</span>
						</span>
					</h1>
					<p className={styles.lede}>
						Turn your posts and blogs into maps and trips inside Stippl, used by 1.5 million travellers. Earn €0.50 per traveller, 80% of your paid guides, and
						keep your own affiliate links.
					</p>
					<div className={styles.cta}>
						<a className={`${styles.btn} ${styles.btnGreen}`} href="#apply">
							Apply to become a creator
						</a>
						<a className={`${styles.btn} ${styles.btnGhost}`} href={CREATOR_PAGE_PATH}>
							See a creator page
						</a>
					</div>
				</div>
				<div className={styles.heroArt} aria-hidden="true">
					<div className={styles.hs}>
						<div className={styles.hsV}>
							<img className={styles.on} src={img("hero.webp")} alt="" />
						</div>
					</div>
					<HeroPhone />
					<span className={`${styles.ptile} ${styles.t1}`}>
						<MapPin fill="#ea5681" />
					</span>
					<span className={`${styles.ptile} ${styles.t2}`}>
						<MoneyBag />
					</span>
					<span className={`${styles.ptile} ${styles.t3}`}>
						<Instagram fill="#7c3aed" />
					</span>
					<span className={`${styles.ptile} ${styles.t4}`}>
						<Compass fill="#e09a1a" />
					</span>
					<span className={styles.hchip}>
						+€0.50 <small>Sarah planned a trip</small>
					</span>
				</div>
			</div>
		</div>
	</section>
);

export default Hero;
